// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getStatesForRescheduleVisit = ({ licensesList, serviceTypeName, serviceTypesList, visitTypeName }) => {
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  const visitTypesOfCurrentServiceType = serviceTypesList?.find(({ Name }) => Name === serviceTypeName)?.VisitTypes
  if (!visitTypesOfCurrentServiceType) return []

  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  const currentVisitTypeId = visitTypesOfCurrentServiceType.find(({ Name }) => Name === visitTypeName)?.VisitTypeId
  if (currentVisitTypeId === undefined) return []

  // flatMap, not map: a map with no else branch returns an array padded with `undefined` holes
  // for every license that does not cover this visit type. Only the covering states belong here.
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  return (licensesList ?? []).flatMap(({ VisitTypes, StateCode }) =>
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    (VisitTypes ?? []).some(({ VisitTypeId }) => VisitTypeId === currentVisitTypeId) ? [StateCode] : [],
  )
}
